import { render, staticRenderFns } from "./ProductSizes.vue?vue&type=template&id=cf224868&"
import script from "./ProductSizes.vue?vue&type=script&lang=js&"
export * from "./ProductSizes.vue?vue&type=script&lang=js&"
import style0 from "./ProductSizes.vue?vue&type=style&index=0&id=cf224868&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SizeGuide: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/SizeGuide.vue').default})
